const NATIVE_DIALOG_INITIALIZED_ATTR = "nativeDialogInitialized";
const BODY_OVERFLOW_BEFORE_OPEN_ATTR = "bodyOverflowBeforeOpen";

const toBoolean = (value, defaultValue) => {
  if (value === undefined) return defaultValue;
  if (value === null) return defaultValue;

  if (value === true || value === false) return value;

  const normalized = String(value).toLowerCase();
  if (normalized === "true") return true;
  if (normalized === "false") return false;

  return defaultValue;
};

const closeOnBackdrop = (dialog) => {
  return toBoolean(dialog.dataset.nativeDialogCloseOnBackdrop, true);
};

const lockBodyScroll = (dialog) => {
  return toBoolean(dialog.dataset.nativeDialogLockBodyScroll, true);
};

const lockBody = (dialog) => {
  if (!lockBodyScroll(dialog)) return;

  if (dialog.dataset[BODY_OVERFLOW_BEFORE_OPEN_ATTR] === undefined) {
    dialog.dataset[BODY_OVERFLOW_BEFORE_OPEN_ATTR] = document.body.style.overflow || "";
  }

  document.body.style.overflow = "hidden";
};

const restoreBody = (dialog) => {
  if (!lockBodyScroll(dialog)) return;

  const before = dialog.dataset[BODY_OVERFLOW_BEFORE_OPEN_ATTR];
  if (before === undefined) return;

  document.body.style.overflow = before;
  delete dialog.dataset[BODY_OVERFLOW_BEFORE_OPEN_ATTR];
};

const setupDialogOnce = (dialog) => {
  if (dialog.dataset[NATIVE_DIALOG_INITIALIZED_ATTR] === "1") return;

  dialog.dataset[NATIVE_DIALOG_INITIALIZED_ATTR] = "1";

  dialog.addEventListener("close", () => {
    restoreBody(dialog);
  });

  dialog.addEventListener("cancel", () => {
    restoreBody(dialog);
  });

  dialog.addEventListener("click", (event) => {
    if (!closeOnBackdrop(dialog)) return;

    if (event.target === dialog) {
      dialog.close();
    }
  });
};

const openById = (id) => {
  if (!id) return;

  const dialog = document.getElementById(id);
  if (!dialog) return;
  if (dialog.tagName !== "DIALOG") return;

  setupDialogOnce(dialog);

  if (dialog.open) return;

  lockBody(dialog);
  try {
    dialog.showModal();
  } catch (error) {
    // showModal() は他のモーダルが既に開いている場合などに失敗しうるため、
    // 事前に適用した body ロックを巻き戻して未処理例外を避ける。
    restoreBody(dialog);
  }
};

const closeById = (id) => {
  if (!id) return;

  const dialog = document.getElementById(id);
  if (!dialog) return;
  if (dialog.tagName !== "DIALOG") return;

  if (!dialog.open) return;

  dialog.close();
  restoreBody(dialog);
};

document.addEventListener("click", (event) => {
  const trigger = event.target.closest?.("[data-dialog-open]");
  if (!trigger) return;

  event.preventDefault();

  openById(trigger.dataset.dialogOpen);
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;

  // 入力中のEnter/Spaceは邪魔しない
  const tagName = event.target?.tagName;
  if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") return;

  const trigger = event.target.closest?.("[data-dialog-open]");
  if (!trigger) return;

  // Spaceはページスクロールになるので抑止
  if (event.key === " ") {
    event.preventDefault();
  }

  openById(trigger.dataset.dialogOpen);
});

document.addEventListener("click", (event) => {
  const closeTrigger = event.target.closest?.("[data-dialog-close]");
  if (!closeTrigger) return;

  const dialog = closeTrigger.closest?.("dialog");
  if (!dialog) return;

  event.preventDefault();

  dialog.close?.();
  restoreBody(dialog);
});

// ページ別の事情で必要になった場合の逃げ道（ただし基本は data-dialog-open を使う）
window.NativeDialog = {
  open: openById,
  close: closeById
};
